'use client';

import { Box, Typography, Button, Stack } from '@mui/material';
import { Component, ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error) {
    // Check if it's a server action mismatch error
    if (error.message.includes('Failed to find Server Action') || 
        error.message.includes('This request might be from an older or newer deployment')) {
      // Force refresh to sync client with server
      window.location.reload();
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <Box
          sx={{
            display: 'flex',
            minHeight: '100vh',
            alignItems: 'center',
            justifyContent: 'center',
            color: 'text.primary',
          }}
        >
          <Box sx={{ textAlign: 'center' }}>
            <Typography variant="h5" component="h2" sx={{ mb: 3 }}>
              Something went wrong
            </Typography>
            <Stack direction="row" spacing={2} justifyContent="center">
              <Button
                variant="outlined"
                onClick={() => window.location.href = '/'}
              >
                Go to Home
              </Button>
              <Button
                variant="contained"
                onClick={() => window.location.reload()}
              >
                Refresh Page
              </Button>
            </Stack>
          </Box>
        </Box>
      );
    }

    return this.props.children;
  }
}